import React from "react"

function CustomTitle({ merchantName }) {
  return (
    <p className="title-text">
      To use this service, Maya will need to share your data with{" "}
      <b>{merchantName}</b> to enable them to:
    </p>
  )
}

export default CustomTitle
